// extracted by mini-css-extract-plugin
module.exports = {"segmentPickerTitle":"SegmentPicker_segmentPickerTitle__lnw5v","segmentPicker":"SegmentPicker_segmentPicker__3Y7N3","segmentPickerCard":"SegmentPicker_segmentPickerCard__1zTHB"};